// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"XK-z","shipmentMessage":"YK-z","shipmentNumber":"ZK-z","trackingProgressContainer":"_K-z"};